// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"ConfirmBlockModal_modalBackdrop__V6qyS","modalContent":"ConfirmBlockModal_modalContent__PEtdI"};